import Image from 'next/image'

import { AspectRatio } from '@/components/primitives/AspectRatio/AspectRatio'
import { toCurrency } from '@/lib/formatPrice'

import { IMAGE_SIZE } from './Cart.constants'

type OnboardingLineItemProps = {
  title: string
  image: {
    url: string
    altText: string
  }
  cost: {
    isDiscounted: boolean
    totalDiscountedPrice: number
    totalOriginalPrice: number
    totalRentalPrice: number
  }
  quantity: number
}

export const OnboardingLineItem = ({ title, image, cost, quantity }: OnboardingLineItemProps) => {
  if (!quantity) return <></>
  const { isDiscounted, totalDiscountedPrice, totalOriginalPrice, totalRentalPrice } = cost

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center gap-4">
        {image.url && (
          <div className="size-14">
            <AspectRatio ratio="1/1">
              <div className="relative size-full overflow-hidden rounded-sm border border-grey-300">
                <Image src={image.url} alt={image.altText || title || ''} fill sizes={IMAGE_SIZE} className="object-cover object-center" />
              </div>
              {quantity && <p className="absolute -right-2 -top-2 size-5 rounded-full bg-green-900 text-center text-sm text-white">{quantity}</p>}
            </AspectRatio>
          </div>
        )}

        <div className="flex flex-col gap-2">
          <div className="flex flex-col gap-2">
            <p className="text-sm font-medium">{title}</p>
            <div className="flex items-center gap-1">
              <p>{toCurrency({ value: totalDiscountedPrice + totalRentalPrice })}</p>
              {isDiscounted && <p className="text-grey-400 line-through">{toCurrency({ value: totalOriginalPrice + totalRentalPrice })}</p>}
            </div>
            <p className="text-xs text-grey-700">Includes annual rental fee of {toCurrency({ value: totalRentalPrice })}.</p>
          </div>
        </div>
      </div>
    </div>
  )
}
